import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { UserStore } from '../../stores/user.store';
import { userFullName } from 'utils/functions/user-name.util';
import { AvatarComponent, IconSize } from '../avatar/avatar.component';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { AuthSessionService } from '../../services/auth-session.service';

@Component({
    selector: 'gcp-workspace-user-profile-menu',
    imports: [
        MatButtonModule,
        AvatarComponent,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        MatDivider,
    ],
    templateUrl: './user-profile-menu.component.html',
    styleUrl: './user-profile-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileMenuComponent {
  private readonly router = inject(Router);
  private readonly authSession = inject(AuthSessionService);

  userStore = inject(UserStore);
  IconSize = IconSize;

  currentUser = computed(() => this.userStore.currentUser());
  readonly fullName = computed(() => userFullName(this.currentUser()));

  openAccountSettings() {
    void this.router.navigate(['/account-settings']);
  }

  handleLogout(): void {
    this.authSession.logout();
  }
}
